// The protocol authoring invariant is exactly one schedule per protocol.
export const resolveScheduleName = (scheduleNames: string[]): string => {
  const [scheduleName, ...rest] = scheduleNames;
  if (scheduleName === undefined || rest.length > 0) {
    throw new Error(
      `Expected exactly one schedule in the protocol, got ${scheduleNames.length.toString()}`
    );
  }
  return scheduleName;
};
